var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgList28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 6C4.22386 6 4 6.22386 4 6.5C4 6.77614 4.22386 7 4.5 7H6.5C6.77614 7 7 6.77614 7 6.5C7 6.22386 6.77614 6 6.5 6H4.5ZM9.5 6C9.22386 6 9 6.22386 9 6.5C9 6.77614 9.22386 7 9.5 7H23.5C23.7761 7 24 6.77614 24 6.5C24 6.22386 23.7761 6 23.5 6H9.5ZM4 13.5C4 13.2239 4.22386 13 4.5 13H6.5C6.77614 13 7 13.2239 7 13.5C7 13.7761 6.77614 14 6.5 14H4.5C4.22386 14 4 13.7761 4 13.5ZM4.5 20C4.22386 20 4 20.2239 4 20.5C4 20.7761 4.22386 21 4.5 21H6.5C6.77614 21 7 20.7761 7 20.5C7 20.2239 6.77614 20 6.5 20H4.5ZM9 13.5C9 13.2239 9.22386 13 9.5 13H23.5C23.7761 13 24 13.2239 24 13.5C24 13.7761 23.7761 14 23.5 14H9.5C9.22386 14 9 13.7761 9 13.5ZM9.5 20C9.22386 20 9 20.2239 9 20.5C9 20.7761 9.22386 21 9.5 21H23.5C23.7761 21 24 20.7761 24 20.5C24 20.2239 23.7761 20 23.5 20H9.5Z",
  fill: "currentColor"
})));
export default SvgList28;